var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.87988 21.9002C9.75738 22.2527 10.7099 22.4627 11.7149 22.5002C13.0724 22.5452 14.3549 22.2677 15.5099 21.7352C14.1299 21.1952 12.8774 20.4002 11.8124 19.4102C11.1166 20.5211 10.0952 21.3906 8.88738 21.9002H8.87988Z",
    fill: "#FF9100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8049 19.4098C9.36744 17.1598 7.88994 13.8973 8.01744 10.3198C8.01744 10.2073 8.02494 10.0873 8.03244 9.97476C6.95059 9.69872 5.81522 9.71165 4.73994 10.0123C4.08744 11.1523 3.69744 12.4573 3.64494 13.8598C3.51744 17.4748 5.70744 20.6323 8.87994 21.9073C10.0912 21.4033 11.1141 20.5325 11.8049 19.4173V19.4098Z",
    fill: "#FFC400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.805 19.4098C12.3897 18.4736 12.7182 17.4003 12.7575 16.2973C12.8625 13.2823 10.8375 10.6948 8.03254 9.96729C8.03254 10.0798 8.01754 10.1998 8.01754 10.3123C7.9548 12.0111 8.26088 13.7033 8.91472 15.2725C9.56855 16.8417 10.5546 18.2506 11.805 19.4023V19.4098Z",
    fill: "#FF9100"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4425 1.5C10.845 2.775 9.58497 4.4625 8.81997 6.405C8.37279 7.54401 8.10706 8.74613 8.03247 9.9675C9.42308 10.327 10.6494 11.1503 11.5085 12.3013C12.3677 13.4523 12.8083 14.8621 12.7575 16.2975C12.7227 17.4013 12.3939 18.4758 11.805 19.41C12.8828 20.4074 14.1366 21.1958 15.5025 21.735C18.2775 20.4525 20.2425 17.7 20.355 14.4375C20.43 12.3225 19.62 10.44 18.4725 8.85C17.2575 7.17 12.4425 1.5075 12.4425 1.5075V1.5Z",
    fill: "#DD2C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.da7ef3eb6dfa83d1951a788c0cd29ace.svg";
export { ForwardRef as ReactComponent };